import { UserRequestData } from '../types/userRequestData'
import axios from 'axios'

export const getLastRequestUser = (clientData: UserRequestData) => axios.post('/api/sitel/information/getLastRequestUser', clientData)
	.then((response) => response.data)